export default __webpack_public_path__ + "static/media/PANTALLAZOS_1.3ed852a2.jpg";